// Each round shows one message/call/offer card. The player must tap Scam
// or Legit before the timer bar empties. SCAM cards carry red_flags used in
// post-answer feedback; LEGIT cards carry a reassurance line explaining
// what makes them safe to ignore.
export const CARD_BANK = [
  {
    id: "c1",
    channel: "TEXT",
    sender: "+1 (302) 555-0199",
    message: "Your package couldn't be delivered. Pay a $2.99 redelivery fee within 1 hour: bit.ly/4kd9pQ",
    label: "SCAM",
    difficulty: "EASY",
    red_flags: [
      "Urgency / short deadline",
      "Shortened, unverifiable link",
      "Unsolicited fee request via text",
    ],
  },
  {
    id: "c2",
    channel: "CALL",
    sender: "Unknown Number",
    message:
      "This is the IRS. You owe back taxes and a warrant is being issued for your arrest unless you pay immediately with gift cards.",
    label: "SCAM",
    difficulty: "EASY",
    red_flags: [
      "Government agencies don't call demanding immediate payment",
      "Gift cards are never a legitimate payment method for taxes",
      "Threat of arrest used to create panic",
    ],
  },
  {
    id: "c3",
    channel: "EMAIL",
    sender: "security-alert@paypa1.com",
    message: "Your account has been limited. Verify your identity within 24 hours or it will be permanently suspended.",
    label: "SCAM",
    difficulty: "EASY",
    red_flags: [
      "Misspelled domain (paypa1, not paypal)",
      "Urgent suspension threat",
      "Generic 'verify your identity' link instead of logging in directly",
    ],
  },
  {
    id: "c4",
    channel: "DM",
    sender: "@CryptoKing_Official",
    message:
      "I turned $500 into $12,000 in 2 weeks with my private trading signal. Send me $200 and I'll double it for you in 48 hours, guaranteed.",
    label: "SCAM",
    difficulty: "MEDIUM",
    red_flags: [
      "\"Guaranteed\" returns don't exist in real investing",
      "Asks you to send money directly to a stranger",
      "Too-good-to-be-true timeline (doubling money in 48 hours)",
    ],
  },
  {
    id: "c5",
    channel: "CALL",
    sender: "Grandma?",
    message: "Grandma, it's me, I'm in jail and need $3,000 wired right now, please don't tell mom and dad.",
    label: "SCAM",
    difficulty: "MEDIUM",
    red_flags: [
      "Caller never says their name, waits for you to say it for them",
      "Demands secrecy from family who could verify the story",
      "Urgent wire transfer request, untraceable and irreversible",
    ],
  },
  {
    id: "c6",
    channel: "TEXT",
    sender: "555-0142",
    message: "Your bank account has been locked due to suspicious activity. Reply with your one-time passcode to unlock it.",
    label: "SCAM",
    difficulty: "MEDIUM",
    red_flags: [
      "A real bank never asks you to text back an OTP code",
      "OTP codes exist specifically to prevent someone else from accessing your account",
    ],
  },
  {
    id: "c7",
    channel: "EMAIL",
    sender: "hr-onboarding@quickhire-remote.net",
    message: "Congratulations, you're hired! To ship your work laptop, please Venmo $350 for an equipment deposit, refundable after 30 days.",
    label: "SCAM",
    difficulty: "MEDIUM",
    red_flags: [
      "Real employers don't ask new hires to pay for their own equipment",
      "Payment requested via Venmo instead of standard payroll/HR processes",
      "Job offer with no interview",
    ],
  },
  {
    id: "c8",
    channel: "CALL",
    sender: "\"Microsoft Support\"",
    message: "We detected a virus on your computer. Please install this remote access tool so our technician can fix it for you right now.",
    label: "SCAM",
    difficulty: "HARD",
    red_flags: [
      "Real tech companies don't cold-call about viruses on your device",
      "Installing remote-access software gives a stranger full control of your computer",
      "Creates urgency around a problem you never reported",
    ],
  },
  {
    id: "c9",
    channel: "DM",
    sender: "Alex_Martinez88",
    message:
      "It's been amazing talking to you these past months. My daughter needs emergency surgery and I'm stuck overseas — could you send $800 via gift card? I'll pay you back the moment I'm home.",
    label: "SCAM",
    difficulty: "HARD",
    red_flags: [
      "A relationship that has never met in person asking for money is a classic pattern",
      "Gift cards are functionally untraceable, unlike a bank transfer",
      "An excuse that conveniently prevents meeting in person or verifying the story",
    ],
  },
  {
    id: "c10",
    channel: "TEXT",
    sender: "Red Cross Relief",
    message: "Disaster relief needed NOW. Donate via this link and we'll match your gift 3x: bit.ly/help-now",
    label: "SCAM",
    difficulty: "HARD",
    red_flags: [
      "Real charities rarely solicit large one-time donations via unsolicited text",
      "Shortened link instead of the charity's actual verified domain",
      "High-pressure \"donate now\" urgency combined with a too-good match offer",
    ],
  },
  {
    id: "c11",
    channel: "EMAIL",
    sender: "billing@spotify.com",
    message: "Your receipt for the Spotify Premium annual plan — $119.88 charged to your card on file.",
    label: "LEGIT",
    difficulty: "EASY",
    reassurance:
      "Matches a real subscription you'd expect, states a specific known amount, and doesn't ask you to click anything or provide information.",
  },
  {
    id: "c12",
    channel: "TEXT",
    sender: "Dr. Chen's Office",
    message: "Reminder: you have a dental cleaning appointment tomorrow at 2:00 PM. Reply C to confirm or call us to reschedule.",
    label: "LEGIT",
    difficulty: "EASY",
    reassurance: "A routine appointment reminder with no payment request, no urgent threat, and a real phone number to call back if needed.",
  },
  {
    id: "c13",
    channel: "EMAIL",
    sender: "no-reply@yourbank.com",
    message: "Fraud Alert: We noticed a charge of $412.00 at an unfamiliar merchant. If this wasn't you, call the number on the back of your card.",
    label: "LEGIT",
    difficulty: "EASY",
    reassurance:
      "Directs you to call the number on your own physical card — not a link or a number in the message — which is exactly the safe way to verify a real fraud alert.",
  },
  {
    id: "c14",
    channel: "TEXT",
    sender: "Amazon",
    message: "Your order #112-4938201 has shipped and is expected to arrive Thursday. Track it in the Amazon app.",
    label: "LEGIT",
    difficulty: "MEDIUM",
    reassurance: "References a specific order number you can independently check by opening the app directly, rather than clicking a link in the text.",
  },
  {
    id: "c15",
    channel: "EMAIL",
    sender: "support@acmehosting.com",
    message: "Following up on ticket #48213 you opened yesterday — we've reset your account password as requested. It will expire in 24 hours if unused.",
    label: "LEGIT",
    difficulty: "MEDIUM",
    reassurance: "Responds to a support ticket you actually opened yourself, referencing its specific number — not an unsolicited message out of nowhere.",
  },
  {
    id: "c16",
    channel: "TEXT",
    sender: "Riverside School District",
    message: "ALERT: All schools closed tomorrow due to winter weather. Classes resume Monday.",
    label: "LEGIT",
    difficulty: "MEDIUM",
    reassurance: "A routine district-wide alert with no request for money, personal information, or a link — just a status update.",
  },
  {
    id: "c17",
    channel: "EMAIL",
    sender: "payroll@yourcompany.com",
    message: "Your direct deposit of $2,140.55 has been processed and will arrive in your account by Friday.",
    label: "LEGIT",
    difficulty: "MEDIUM",
    reassurance: "A routine payroll notice with a specific, expected amount, sent from your actual employer's domain, asking for nothing in return.",
  },
  {
    id: "c18",
    channel: "EMAIL",
    sender: "billing@electricco.com",
    message: "Your autopay of $87.42 was successfully processed for this month's electric bill. No action needed.",
    label: "LEGIT",
    difficulty: "HARD",
    reassurance: "A standard autopay confirmation with no urgency, no link to click, and no request for information — it's simply informing you something already happened.",
  },
  {
    id: "c19",
    channel: "TEXT",
    sender: "Jamie",
    message: "Hey! Still on for dinner at 7? Let me know if that still works for you 😊",
    label: "LEGIT",
    difficulty: "HARD",
    reassurance: "A message from a name already in your contacts, about a plan you'd recognize, with nothing being asked for besides a reply.",
  },
  {
    id: "c20",
    channel: "CALL",
    sender: "State Farm Insurance",
    message: "Hi, this is Marcus from your local State Farm office confirming your auto policy renewal date is next month — no action needed, just a heads up.",
    label: "LEGIT",
    difficulty: "HARD",
    reassurance:
      "Calls from a known, existing insurance provider confirming an expected renewal date, with an explicit \"no action needed\" rather than any request for payment or information.",
  },
];

export const BUCKETS = [
  { id: "SCAM", label: "Scam", hint: "Flag it", accent: "danger" },
  { id: "LEGIT", label: "Legit", hint: "It's fine", accent: "lime" },
];

export const DIFFICULTY_POINTS = { EASY: 30, MEDIUM: 60, HARD: 100 };

export const STARTING_LIVES = 3;
export const CARDS_PER_LEVEL = 8;
// Longer than Budget Blitz's timing — these are full sentences to read,
// not two-word line items.
export const BASE_TIME_MS = 7000;
export const MIN_TIME_MS = 3000;
export const TIME_STEP_PER_LEVEL = 280;

export function pickCard(lastId) {
  let next = CARD_BANK[Math.floor(Math.random() * CARD_BANK.length)];
  // Avoid immediate repeats so it doesn't feel stale.
  let guard = 0;
  while (next.id === lastId && guard < 6) {
    next = CARD_BANK[Math.floor(Math.random() * CARD_BANK.length)];
    guard += 1;
  }
  return next;
}

export function timeLimitForLevel(lvl) {
  return Math.max(MIN_TIME_MS, BASE_TIME_MS - (lvl - 1) * TIME_STEP_PER_LEVEL);
}

export function computeGain(difficulty, combo) {
  const comboMultiplier = 1 + combo * 0.25;
  return Math.max(1, Math.round(DIFFICULTY_POINTS[difficulty] * comboMultiplier));
}
